<div
  class="banner d-none d-lg-flex"
  role="banner"
  [style.background-image]="
    'url(' + ('banners/banner.jpg' | contentAssetImage) + ')'
  "
>
  <div class="container d-flex align-items-center justify-content-between">
    <h1 class="banner-title">{{ name$ }}</h1>
    <img
      class="banner-logo"
      [src]="'logos/phxid-logo.svg' | contentAssetImage"
      alt="PHX ID logo"
      draggable="false"
    />
  </div>
</div>

<fgb-page-header
  [pageTitle]="'account.nav.profile'"
  [showBalance]="true"
></fgb-page-header>

<div class="container account-container">
  <div class="row">
    <div class="col-12 col-lg-6 d-none d-lg-block">
      <h5 class="my-3 mt-lg-0">
        {{ "account.member.card.title" | translate }}
      </h5>
      <fgb-member-card></fgb-member-card>
    </div>
    <div class="col-12 col-lg-6">
      <h5 class="mt-lg-0 mb-lg-3">{{ "account.details.title" | translate }}</h5>
      <fgb-account-details></fgb-account-details>
    </div>
  </div>

  <!-- DSN Link iframe -->
  <iframe
    [src]="dsnIframeUrl"
    class="dsn-iframe"
    frameborder="0"
    allowfullscreen
  ></iframe>
</div>
